import { RichTextCssTextStyles } from '@framework/form/inputs/rich-text/style/RichTextCssTextStyles.ts';
import styled, { css } from 'styled-components';
import { StyledRteHtmlText } from './StyledRteHtmlText.tsx';
import { StyledRteHtmlTextNoFont } from './StyledRteHtmlTextNoFont.tsx';

/**
 * Componente che renderizza un elemento senza alcun stile
 */
export const StyledRichTextAdvancedText = styled.span<{
  inline?: boolean;
  hasCustomFont?: boolean;
}>`
  &&& {
    margin-bottom: 0;
    > p {
      display: inline;
      margin-bottom: 0;
    }
    > p[style*='text-align:'] {
      display: block;
    }
    // nascondiamo campo se vuoto per accessibilità
    &:empty {
      display: none;
    }

    ${props =>
      props.inline &&
      css`
        display: inline;
        margin-bottom: 0;
        p {
          display: inline;
          margin-right: 0.25em;
          margin-bottom: 0;
          &:last-child {
            margin-right: 0;
          }
        }
      `}
    ${props =>
      props.hasCustomFont
        ? css`
            ${StyledRteHtmlText}
          `
        : css`
            ${StyledRteHtmlTextNoFont}
          `}
  }
  & + & {
    // modificato selettore per non includere i figli di StyledRichTextAdvancedText
    // con il selettore display block (ul, ol, ecc.) altrimenti il padding sposta l'elemento in basso
    > p {
      // dato che il componente è uno span inseriamo uno spazio tra un elemento e l'altro
      // per evitare che vengano renderizzati attaccati
      padding-left: 0.25em;
    }
  }

  span.compute-expression-reference {
    color: ${props => props.theme.colorPrimary};
    font-weight: bold;
  }

  ${RichTextCssTextStyles}
`;
